/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CampDto2 } from '../../models/camp-dto-2';
import { CampShowResponse2 } from '../../models/camp-show-response-2';

export interface PatchCampUpdate$Params {
  name: string;
      body: CampDto2
}

export function patchCampUpdate(http: HttpClient, rootUrl: string, params: PatchCampUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<CampShowResponse2>> {
  const rb = new RequestBuilder(rootUrl, patchCampUpdate.PATH, 'patch');
  if (params) {
    rb.path('name', params.name, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CampShowResponse2>;
    })
  );
}

patchCampUpdate.PATH = '/v1/camp/{name}';
